import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./board-dashboard/board-dashboard.component').then(m => m.BoardDashboardComponent),
  },
  {
    path: 'appointments',
    loadComponent: () => import('./meetings/board-meetings.component').then(m => m.BoardMeetingsComponent),
  },
  {
    path: 'board-members',
    loadComponent: () =>
      import('./board-list/board-list.component').then(m => m.BoardListComponent),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BoardRoutingModule {}
